module.exports = __webpack_public_path__ + "img/20210209_Cell.27195385.png";